import {useMandantenHandling} from "../../hooks/mandanten/useMandantenHandling";
import Layout from "../../components/Layout";
import {capitalize, DialogActions, DialogContent, Paper, Typography} from "@mui/material";
import {mandantenStyles} from "../../styles/mandanten/mandanten.styles";
import {Form, Formik, FormikProps} from "formik";
import FieldsContentMandant from "../../components/mandanten/FieldsContentMandant";
import type { MandantFormValues } from "../../types/mandantenTypes";
import SubmitButton from "../../components/SubmitButton";
import {useMandantCreateForm} from "../../hooks/mandanten/useMandantCreateForm";
import Guard from "../../components/guards/Guard";
import ErrorAlert from "../../components/ErrorAlert";
import {notPermitted} from "../../errors";
import {permissions} from "../../permissions";

export default function PageCreateMandant() {
    const {translation, canCreateMandantField} = useMandantenHandling();
    const formikProps = useMandantCreateForm();

    return (
        <Layout
            title={capitalize(translation('client-create'))}
            back={"/mandanten"}
        >
            <Guard
                permission={permissions.mandanten.create}
                fallback={<ErrorAlert error={notPermitted()}/>}
            >
                <Paper id={'page-create-mandant-paper'}
                       elevation={1}
                       sx={mandantenStyles.pageCreateMandant.paper}
                >
                    <Formik {...formikProps}>
                        {({isSubmitting, isValidating, isValid, dirty}: FormikProps<MandantFormValues>) => (
                            <Form id={'form-create-mandant'}>
                                <Typography variant="h5">
                                    {capitalize(translation('client-create'))}
                                </Typography>
                                <DialogContent id={'page-create-mandant-dialog-content'}>
                                    <FieldsContentMandant canEditFields={canCreateMandantField()}/>
                                </DialogContent>
                                <DialogActions id={'page-create-mandant-dialog-actions'}>
                                    <SubmitButton id={'page-create-mandant-submit-button'}
                                                  form={'form-create-mandant'}
                                                  type={'submit'}
                                                  variant={'contained'}
                                                  color={'secondary'}
                                                  loading={isSubmitting}
                                                  disabled={isValidating || !isValid || !dirty}
                                    >
                                        {isSubmitting ? capitalize(translation('creating')) : capitalize(translation('create'))}
                                    </SubmitButton>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </Paper>
            </Guard>
        </Layout>
    );
}